import Vue from "vue";
import axios from "axios";

const types = {
    SET_MODAL_SEND: "SET_MODAL_SEND",
    SET_SNACKBAR: "SET_SNACKBAR",
};

const state = {
    modalSend: false,
    snackbar: {
      color: 'success',
      value: false,
      msg: '',
    },    
};

const actions = {    
    modalSend({ commit, dispatch }, data) {
        commit(types.SET_MODAL_SEND, data);
    },
    setSnackbar({ commit, dispatch }, data) {
        commit(types.SET_SNACKBAR, data);
    },    
}

const mutations = {
    [types.SET_MODAL_SEND](state, data) {
        state.modalSend = data;
    },
    [types.SET_SNACKBAR](state, data) {
        state.snackbar = data;
    },    
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};